import type {
  AudioPlaybackAction,
  AudioPlaybackState,
} from "../types/audio-playback";

function createInitialAudioPlaybackState(
  initialDurationSeconds: number,
): AudioPlaybackState {
  return {
    currentTimeSeconds: 0,
    durationSeconds: initialDurationSeconds,
    hasError: false,
    isPlaying: false,
    isReady: initialDurationSeconds > 0,
    volume: 1,
  };
}

function audioPlaybackReducer(
  state: AudioPlaybackState,
  action: AudioPlaybackAction,
): AudioPlaybackState {
  switch (action.type) {
    case "reset":
      return createInitialAudioPlaybackState(action.initialDurationSeconds);
    case "metadata-loaded":
      return {
        ...state,
        currentTimeSeconds: action.currentTimeSeconds,
        durationSeconds: action.durationSeconds ?? state.durationSeconds,
        hasError: false,
        isReady: Boolean(action.durationSeconds) || state.durationSeconds > 0,
      };
    case "time-updated":
    case "seeked":
      return {
        ...state,
        currentTimeSeconds: action.currentTimeSeconds,
      };
    case "play":
      return {
        ...state,
        isPlaying: true,
      };
    case "pause":
      return {
        ...state,
        isPlaying: false,
      };
    case "ended":
      return {
        ...state,
        currentTimeSeconds: action.currentTimeSeconds,
        isPlaying: false,
      };
    case "error":
    case "play-failed":
      return {
        ...state,
        hasError: true,
        isPlaying: false,
        isReady: false,
      };
    case "waiting":
      return {
        ...state,
        isPlaying: action.isPlaying,
      };
    case "volume-changed":
      return {
        ...state,
        volume: action.volume,
      };
    default:
      return state;
  }
}

export { audioPlaybackReducer, createInitialAudioPlaybackState };
